import { Branded } from '@/common/types/branded';

export type AnyGlobalId = Branded<string, 'AnyLayerGlobalId'>;
export type AnyLayerId = Branded<number, 'AnyLayerId'>;
export type ObjectId = Branded<number | null | undefined, 'ObjectId'>;

// Copied from: https://github.com/Volue/pg-anb-grid-planner-web/blob/d5be206a5b9fe8fcfca5d0b3d211828ce9dafaeb/src/shared/lib/gis/models/arcgis.ts
// In case of more operations with features, grab from that file
export class Feature {
  static attributeOf<T = unknown>(feature: __esri.Graphic, fieldName: string) {
    if (!feature.attributes) return undefined as T;
    const featureWithLowerCasedAttributes = Object.fromEntries(
      Object.entries(feature.attributes).map(([key, value]) => [key.toLocaleLowerCase(), value]),
    )
    return featureWithLowerCasedAttributes[fieldName.toLowerCase()] as T;
  }
}
